/* global axios */

import ApiClient from './ApiClient';

class WhatsappStickers extends ApiClient {
  constructor() {
    super('whatsapp_stickers', { accountScoped: true });
  }

  get({ searchKey } = {}) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  // Se sube por multipart y no por direct upload: el servidor tiene que
  // normalizar el archivo a WebP 512x512 antes de guardarlo.
  create({ file, name }) {
    const formData = new FormData();
    formData.append('whatsapp_sticker[file]', file);
    if (name) formData.append('whatsapp_sticker[name]', name);

    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new WhatsappStickers();
